import { useLocation } from "react-router-dom";

import { Nullable } from "foundation-ts/types";

const useQueryParam = (key: string): Nullable<string> => {
    const { search } = useLocation();
    return new URLSearchParams(search).get(key);
}

export default useQueryParam;